var styleDataHash = '5933e0ab';  
export const injectCss = (() => {
  var css = `.MP0yg,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}._3mPCj{color:var(--ricos-custom-link-color,var(--ricos-action-color,#116dff));font-family:var(--ricos-custom-link-font-family,unset);font-size:var(--ricos-custom-link-font-size,unset);font-style:var(--ricos-custom-link-font-style,unset);font-weight:var(--ricos-custom-link-font-weight,unset);letter-spacing:var(--ricos-custom-link-letter-spacing,unset);line-height:var(--ricos-custom-link-line-height,unset);min-height:var(--ricos-custom-link-min-height,unset);text-decoration:var(--ricos-custom-link-text-decoration,none)}@supports not (contain:inline-size){@media only screen and (max-width:480px){._3mPCj{font-size:var(--ricos-custom-link-font-size,unset)}}}@container (width < 480px){._3mPCj{font-size:var(--ricos-custom-link-font-size,unset)}}.q2XJg:hover{cursor:text}.uUNDj:hover{cursor:pointer}.EuNmJ{display:flex;margin-right:5px}.QjS8-{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));max-width:270px;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.QjS8-:hover{text-decoration:underline}.DdpWo:hover{cursor:pointer}@supports not (contain:inline-size){@media only screen and (max-width:480px){.QjS8-{max-width:160px}}}@container (width < 480px){.QjS8-{max-width:160px}}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





